import React from 'react';
import Chart from "react-apexcharts";
//-------------------------------------------

//Chart.register(CategoryScale);

function ApexLineTemp(props){


  const data = {
          
    series: [{
      name: "Temparature",
      data:  [
          {
            x: "02-10-2017 06:00",
            y: 44
          },
          {
            x: "02-10-2017 07:30",
            y: 49
          },
          
          {
            x: "02-10-2017 07:35",
            y: 50
          },
          {
            x: "02-10-2017 08:00",
            y: 51
          },
          {
            x: "02-10-2017 09:10",
            y: 63
          },
          {
            x: "02-10-2017 10:55",
            y: 43
          },
          {
            x: "02-10-2017 11:48",
            y: 52
          },
          {
            x: "02-10-2017 13:10",
            y: 46
          },
          {
            x: "02-10-2017 14:55",
            y: 33
          },
          {
            x: "02-10-2017 15:48",
            y: 52
          },
          {
            x: "02-10-2017 16:30",
            y: 43
          },
          {
            x: "02-10-2017 17:55",
            y: 48
          },
          {
            x: "02-10-2017 18:48",
            y: 52
          },
          {
            x: "02-10-2017 19:30",
            y: 43
          },
          {
            x: "02-10-2017 20:55",
            y: 56
          },
          {
            x: "02-10-2017 21:48",
            y: 52
          },
          {
            x: "02-11-2017 01:00",
            y: 34
          },
          {
            x: "02-11-2017 03:30",
            y: 40
          },
          {
            x: "02-11-2017 04:35",
            y: 51
          },
          {
            x: "02-11-2017 05:10",
            y: 45
          },
          {
            x: "02-11-2017 06:55",
            y: 57
          },
          {
            x: "02-11-2017 07:48",
            y: 42
          }
     
        ]
    }],
    options: {
      chart: {
        id: 'area-datetime',
        type: 'area',
        height: 350,
        toolbar: { show: true },
        zoom: {
          autoScaleYaxis: true
        }
      },
      
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 0,
      },
      xaxis: {
        type: 'datetime',
        min: new Date('10 Feb 2017  06:00').getTime(),
        //tickAmount: 6,
        labels: {
          datetimeUTC: false
        }
        
      },
      tooltip: {
        x: {
          format: 'dd MMM yyyy HH:mm'
        }
      },colors: ["#2c97f3"],
      stroke: {
        width: [1],
        curve: 'smooth',
      },
      
  
      annotations: {
          yaxis: [ {
            y: 60,
            borderColor: '#dc3545',
            opacity: 0.2,
            label: {
              borderColor: '#dc3545',
              style: {
                fontSize: '10px',
                color: '#fff',
                background: '#dc3545',
              },
              text: 'High Voltage',
            }
          }]}
  
  
  
    },
  
  
  
    seriesLine: [{
      data:  [
          {
            x: "02-10-2017 06:00",
            y: 44
          },
          {
            x: "02-10-2017 07:30",
            y: 43
          },
          
          {
            x: "02-10-2017 07:35",
            y: 54
          },
          {
            x: "02-10-2017 08:35",
            y: 51
          },
          {
            x: "02-10-2017 09:10",
            y: 63
          },
          {
            x: "02-10-2017 10:55",
            y: 43
          },
          {
            x: "02-10-2017 11:48",
            y: 52
          },
          {
            x: "02-10-2017 13:10",
            y: 46
          },
          {
            x: "02-10-2017 14:55",
            y: 33
          },
          {
            x: "02-10-2017 15:48",
            y: 52
          },
          {
            x: "02-10-2017 16:10",
            y: 43
          },
          {
            x: "02-10-2017 17:55",
            y: 48
          },
          {
            x: "02-10-2017 18:48",
            y: 52
          },
          {
            x: "02-10-2017 19:10",
            y: 43
          },
          {
            x: "02-10-2017 20:55",
            y: 56
          },
          {
            x: "02-10-2017 21:48",
            y: 52
          },
          {
            x: "02-11-2017 01:00",
            y: 24
          },
          {
            x: "02-11-2017 03:30",
            y: 23
          },
          {
            x: "02-11-2017 04:35",
            y: 31
          },
          {
            x: "02-11-2017 05:10",
            y: 45
          },
          {
            x: "02-11-2017 06:55",
            y: 57
          },
          {
            x: "02-11-2017 07:48",
            y: 42
          }
     
        ]
    }],
    optionsLine: {
      chart: {
        id: 'chart1',
        height: 130,
        type: 'area',
        brush:{
          target: 'area-datetime',
          enabled: true
        },
        selection: {
          enabled: true,
          xaxis: {
            min: new Date('10 Feb 2017  06:00').getTime(),
            
          }
        },
      },
      colors: ['#2c97f3'],
      fill: {
        type: 'gradient',
        gradient: {
          opacityFrom: 0.5,
          opacityTo: 0.5,
        }
      },
      xaxis: {
        type: 'datetime',
        min: new Date('10 Feb 2017  06:00').getTime(),
        //tickAmount: 6,
        labels: {
          datetimeUTC: false
        }
        
      },
      yaxis: {
        tickAmount: 2
      }
    },
  
  
  
    selection: 'one_year',
  
  };
  

    return (
       
        <>
      

          <Chart
        options={data.options}
        series={data.series}
        type="line"
        height={350}
      />

        <div id="chart-line">
        <Chart options={data.optionsLine} series={data.seriesLine} type="area" height={130} />
        </div>



        </>
    )
}

export default ApexLineTemp;



